import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API from '../api';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0); // 0=phone, 1=otp, 2=newpass
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [demoOtp, setDemoOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const sendOtp = async () => {
    if (!/^\d{9}$/.test(phone)) { setError('Enter a valid 9-digit phone number'); return; }
    setLoading(true); setError('');
    try {
      const { data } = await API.post('/users/forgot-password', { phone: '+251' + phone });
      setDemoOtp(data.demo_otp || '');
      setStep(1);
    } catch (err) {
      setError(err.response?.data?.message || 'Phone number not found.');
    } finally { setLoading(false); }
  };

  const verifyOtp = () => {
    if (otp.length !== 6) { setError('Enter the 6-digit code'); return; }
    setError('');
    setStep(2);
  };

  const resetPassword = async () => {
    if (newPassword.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (newPassword !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true); setError('');
    try {
      await API.post('/users/reset-password', { phone: '+251' + phone, otp, newPassword });
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: 'linear-gradient(to bottom, #3B1F0F, #7A4020)' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontSize: 26, fontWeight: 900 }}>All <span style={{ color: '#f97316' }}>Things</span></h1>
          <p style={{ color: '#ffffff', marginTop: 6 }}>Reset your password</p>
        </div>

        <div style={{ background: '#3B1F0F', border: '1px solid #7A402050', borderRadius: 16, padding: 32 }}>
          {error && <div style={errStyle}>{error}</div>}

          {/* Step indicator */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 24 }}>
            {['Phone', 'Verify', 'New Password'].map((label, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17, fontWeight: 700,
                  background: i < step ? '#22c55e' : i === step ? '#f97316' : '#262626',
                  color: i <= step ? '#000' : '#666' }}>
                  {i < step ? '✓' : i + 1}
                </div>
                {i < 2 && <div style={{ width: 24, height: 2, background: i < step ? '#22c55e' : '#262626' }} />}
              </div>
            ))}
          </div>

          {step === 0 && (
            <div>
              <p style={{ color: '#ffffff', fontSize: 16, marginBottom: 20 }}>Enter your registered phone number and we'll send you a verification code.</p>
              <label style={lbl}>Phone Number</label>
              <div style={{ display: 'flex', alignItems: 'center', background: '#2a1208', border: '1px solid #7A402060', borderRadius: 8, overflow: 'hidden', marginBottom: 20 }}>
                <span style={{ padding: '11px 12px', color: '#f97316', fontWeight: 700, fontSize: 17, borderRight: '1px solid #7A402060' }}>+251</span>
                <input type="tel" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, '').slice(0, 9))} maxLength={9} placeholder="9XX XXX XXX"
                  style={{ flex: 1, padding: '11px 12px', background: 'transparent', border: 'none', color: '#fff', fontSize: 16, outline: 'none' }} />
              </div>
              <button onClick={sendOtp} disabled={loading} style={btn}>{loading ? 'Sending...' : 'Send Verification Code'}</button>
            </div>
          )}

          {step === 1 && (
            <div>
              <p style={{ color: '#ffffff', fontSize: 16, marginBottom: 8 }}>Enter the 6-digit code sent to <strong style={{ color: '#fff' }}>+251{phone}</strong></p>
              {demoOtp && (
                <div style={{ background: '#22c55e15', border: '1px solid #22c55e40', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 16, color: '#22c55e' }}>
                  🔔 Demo mode — your code is: <strong style={{ fontSize: 18, letterSpacing: 4 }}>{demoOtp}</strong>
                </div>
              )}
              <label style={lbl}>Verification Code</label>
              <input type="tel" value={otp} onChange={e => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))} maxLength={6} placeholder="000000"
                style={{ ...inp, letterSpacing: 8, fontSize: 22, textAlign: 'center', marginBottom: 20 }} />
              <button onClick={verifyOtp} style={btn}>Verify Code</button>
              <button onClick={() => { setStep(0); setOtp(''); setError(''); }} style={backBtn}>Back</button>
            </div>
          )}

          {step === 2 && (
            <div>
              <p style={{ color: '#ffffff', fontSize: 16, marginBottom: 20 }}>Enter your new password.</p>
              <label style={lbl}>New Password</label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Min. 6 characters" style={{ ...inp, marginBottom: 14 }} />
              <label style={lbl}>Confirm Password</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat password" style={{ ...inp, marginBottom: 20 }} />
              <button onClick={resetPassword} disabled={loading} style={btn}>{loading ? 'Resetting...' : 'Reset Password'}</button>
            </div>
          )}
        </div>

        <p style={{ textAlign: 'center', color: '#ffffff', marginTop: 18, fontSize: 16 }}>
          Remember your password? <Link to="/login" style={{ color: '#f97316' }}>Sign In</Link>
        </p>
      </div>
    </div>
  );
}

const inp = { width: '100%', padding: '11px 14px', background: '#2a1208', border: '1px solid #7A402060', borderRadius: 8, color: '#fff', fontSize: 16 };
const lbl = { display: 'block', fontSize: 16, color: '#d4a574', marginBottom: 6 };
const btn = { width: '100%', padding: '13px', background: '#f97316', color: '#000', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 17, cursor: 'pointer', marginBottom: 10 };
const backBtn = { width: '100%', padding: '11px', background: 'transparent', color: '#ffffff', border: '1px solid #7A402060', borderRadius: 8, fontSize: 16, cursor: 'pointer' };
const errStyle = { background: '#ef444420', border: '1px solid #ef4444', color: '#ef4444', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 16 };
